export const CEREBRO_BASE_URL = process.env.EXPO_PUBLIC_CEREBRO_BASE_URL;
export const MESSENGER_BASE_URL = process.env.EXPO_PUBLIC_MESSENGER_BASE_URL;
export const NETWORK_BASE_URL = process.env.EXPO_PUBLIC_NETWORK_BASE_URL;
export const EVENTS_BASE_URL = process.env.EXPO_PUBLIC_EVENTS_BASE_URL;
export const PROFILE_BASE_URL = process.env.EXPO_PUBLIC_PROFILE_BASE_URL;
export const GAMIFICATION_BASE_URL =
  process.env.EXPO_PUBLIC_GAMIFICATION_BASE_URL;
export const NOTIFICATIONS_WEBSOCKET_URL =
  process.env.EXPO_PUBLIC_NOTIFICATIONS_WEBSOCKET_URL;
export const NOTIFICATIONS_BASE_URL =
  process.env.EXPO_PUBLIC_NOTIFICATIONS_BASE_URL;
export const TICKET_CHECKOUT_URL = process.env.EXPO_PUBLIC_TICKET_CHECKOUT_URL;
export const LIVEKIT_URL = process.env.EXPO_PUBLIC_LIVEKIT_URL;
export const INSIGHTS_BASE_URL = process.env.EXPO_PUBLIC_INSIGHTS_BASE_URL;
export const SHORT_URL_DOMAIN = process.env.EXPO_PUBLIC_SHORT_URL_DOMAIN;
